module.exports = __webpack_public_path__ + "static/media/fuelsensor2.86d1f684.jpg";